import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
} from '@mui/material';
import {
  EmojiPeople,
  Favorite,
  Speed,
} from '@mui/icons-material';
import { Style } from './Style';

const About = ({id}) => {
  return (
    <Box id="about" sx={{ py: 8, backgroundColor: '#f8f9fa' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          component="h2"
          textAlign="center"
          gutterBottom
          sx={{
           ...Style.commonHeading,
          //  mt:id="about"? "20px":"0px"
          }}
        >
          About Us
        </Typography>
        
        <Typography
          variant="h6"
          textAlign="center"
          sx={{
            color: 'text.secondary',
            mb: 6,
            maxWidth: '600px',
            mx: 'auto',
            lineHeight: 1.6,
          }}
        >
          Welcome to our innovative booking platform! We're dedicated to simplifying 
          the process of scheduling appointments for clinics, beauty parlors, and salons.
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Paper
              elevation={3}
              sx={{
              ...Style.AboutPaper1
              }}
            >
              <EmojiPeople
                sx={{
                  fontSize: 60,
                  color: 'primary.main',
                  mb: 2,
                }}
              />
              <Typography variant="h5" gutterBottom fontWeight="bold">
                Customer-Focused
              </Typography>
              <Typography variant="body1" color="text.secondary">
                We understand that your time is valuable, which is why we've created 
                a seamless system that lets you book your next appointment with ease.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper
              elevation={3}
              sx={{
             ...Style.AboutPaper2
              }}
            >
              <Favorite
                sx={{
                  fontSize: 60,
                  color: 'secondary.main',
                  mb: 2,
                }}
              />
              <Typography variant="h5" gutterBottom fontWeight="bold">
                Our Mission
              </Typography>
              <Typography variant="body1" color="text.secondary">
                To connect you with your favorite service providers and make booking 
                as simple as a few taps on your phone.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper
              elevation={3}
              sx={{
              ...Style.AboutPaper3
              }}
            >
              <Speed
                sx={{
                  fontSize: 60,
                  color: 'success.main',
                  mb: 2,
                }}
              />
              <Typography variant="h5" gutterBottom fontWeight="bold">
                Fast & Reliable
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Our platform is designed for both customers and businesses, 
                ensuring a smooth experience for everyone involved.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;

